export default __webpack_public_path__ + "static/media/3061.a74adbc8.jpg";